
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface UseNewsAlertActionsProps {
  onUpdate: () => void;
}

export const useNewsAlertActions = ({ onUpdate }: UseNewsAlertActionsProps) => {
  const markAsRead = async (alertId: string) => {
    try {
      const { error } = await supabase
        .from('client_news_alerts')
        .update({ is_read: true })
        .eq('id', alertId);

      if (error) throw error;
      
      onUpdate();
      toast.success("Alert marked as read.");
    } catch (error) {
      console.error('Error marking alert as read:', error);
      toast.error('Failed to mark alert as read');
    }
  };

  const markAsUnread = async (alertId: string) => {
    try {
      const { error } = await supabase
        .from('client_news_alerts')
        .update({ is_read: false })
        .eq('id', alertId);

      if (error) throw error;
      
      onUpdate();
      toast.success("Alert marked as unread.");
    } catch (error) {
      console.error('Error marking alert as unread:', error);
      toast.error('Failed to mark alert as unread');
    }
  };

  return { markAsRead, markAsUnread };
};
